import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "terms",
  "data-qe-id": "terms-modal"
}

import TermsContentDefault from './TermsContentDefault.vue'
import TermsContentRommeMasters from './TermsContentRommeMasters.vue'
import TermsContentSkatMasters from './TermsContentSkatMasters.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CTerms',
  props: {
    isMasters: { type: Boolean, default: false },
    gameType: {},
    show: { type: Boolean, default: false }
  },
  emits: ['close-terms'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
function onClose() {
  emit('close-terms')
}

return (_ctx: any,_cache: any) => {
  const _component_modal_layout = _resolveComponent("modal-layout")!
  const _component_modal_app = _resolveComponent("modal-app")!
  const _component_gd_modal = _resolveComponent("gd-modal")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_gd_modal, {
          onCloseBG: onClose,
          onCloseESC: onClose,
          onClose: onClose
        }, {
          default: _withCtx(() => [
            _createVNode(_component_modal_app, { l: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_modal_layout, null, {
                  default: _withCtx(() => [
                    (_ctx.isMasters)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.gameType === 'ska')
                            ? (_openBlock(), _createBlock(TermsContentSkatMasters, { key: 0 }))
                            : _createCommentVNode("", true),
                          (_ctx.gameType === 'rom')
                            ? (_openBlock(), _createBlock(TermsContentRommeMasters, { key: 1 }))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createBlock(TermsContentDefault, { key: 1 }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})